module.exports = __webpack_public_path__ + "img/solo act___.ea89db32.png";